/* tslint:disable */
/* eslint-disable */
/**
 * incidentsv2
 * incidentsv2
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IncidentSettingCreateResponse
 */
export interface IncidentSettingCreateResponse {
    /**
     * 
     * @type {string}
     * @memberof IncidentSettingCreateResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof IncidentSettingCreateResponse
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof IncidentSettingCreateResponse
     */
    priority?: number;
}

/**
 * Check if a given object implements the IncidentSettingCreateResponse interface.
 */
export function instanceOfIncidentSettingCreateResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function IncidentSettingCreateResponseFromJSON(json: any): IncidentSettingCreateResponse {
    return IncidentSettingCreateResponseFromJSONTyped(json, false);
}

export function IncidentSettingCreateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncidentSettingCreateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'priority': !exists(json, 'priority') ? undefined : json['priority'],
    };
}

export function IncidentSettingCreateResponseToJSON(value?: IncidentSettingCreateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'priority': value.priority,
    };
}

